// extracted by mini-css-extract-plugin
export default {"card_container":"styles_card_container__xWwV8","left":"styles_left__ZOxJ5","right":"styles_right__Za7KB"};